<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutItems.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutItems.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div>
        <div class="card card-cascade mb-3"
             v-for="(basket_items,index) in basket_records">
            <div class="card-body">
<!--                <h6 :data-ticket-type="index">-->
<!--                    <bold-words :word="{-->
<!--                        text: (index == 'ADDON')?'Extras':`${index} tickets`-->
<!--                        }"-->
<!--                    />-->
<!--                </h6>-->

                <article v-for="basket_item in basket_items"
                         class="row d-flex align-items-center">
                    <div class="col-12 col-md-6 m-x my-1"
                    >
                        <div class="mb-1">
                            <small>{{lang('title',basket_item.lang)}}</small>
                            <h6 class="m-0">
                                <bold-words :word="{
                                                text:lang('title',basket_item.ticket_data.lang)
                                                }"
                                />
                            </h6>
                        </div>
                        <div class="d-inline-block d-md-none">
                            {{truncate(lang('description.short',basket_item.ticket_data.lang))}}
                        </div>
                    </div>

                    <div class="d-flex col-12 col-md-6 justify-content-between justify-content-md-end align-items-center m-x my-1">
                        <!--                        the adder buttons-->
                        <div class="btn-group ml-2 mr-5"
                             data-toggle="buttons">
                            <div class="ticket-item--remove btn btn-sm btn-primary waves-effect waves-light"
                                 v-on:click="remove(basket_item.ticket_data.ticket_id)"
                            >
                                <i class="material-icons"
                                   aria-hidden="true">remove_circle_outline</i>
                            </div>
                            <div class="ticket-item--add btn btn-sm btn-primary waves-effect waves-light"
                                 v-on:click="add(basket_item.ticket_data.ticket_id,basket_item)"
                            >
                                <i class="material-icons"
                                   aria-hidden="true">add_circle_outline</i>
                            </div>
                        </div>
                        <div>
                            <span class="ticket-quantity">{{basket_item.quantity}} x </span>
                        </div>

                        <div class="ticket--discount text-right">
                            <template v-if="basket_item.ticket_data.discount">
                                <span v-if="basket_item.ticket_data.discount_type === 'percentage'">
                                    {{basket_item.ticket_data.discount_value}}
                                    <span>%</span>
                                </span>
                                <span v-else
                                      v-html="rawPrice(basket_item.ticket_data.discount_value,false)"
                                ></span>
                                <span>off</span>
                            </template>
                        </div>

                        <div class="font-weight-bold w-25 text-right">
                            <template v-if="basket_item.ticket_data.discount">
                                <!--                                {{log(basket_item.ticket_data.price,basket_item.ticket_data.discount,basket_item.ticket_data.price - basket_item.ticket_data.discount,-->
                                <!--                                basket_item.quantity * (basket_item.ticket_data.price - basket_item.ticket_data.discount)-->
                                <!--                                )}}-->
                                <span v-html="rawPrice( (basket_item.quantity * basket_item.ticket_data.price) - basket_item.ticket_data.discount,false)"></span>
                            </template>
                            <template v-else>
                                <span v-html="rawPrice(basket_item.quantity * basket_item.ticket_data.price,false)"></span>
                            </template>
                        </div>
                    </div>
                    <hr class="d-block w-100">
                </article>
            </div>
        </div>
        <CheckoutVoucherCode v-if="basket_records"
                             :voucher_code_status="voucher_code_status"
                             :voucher_response="voucher_response"
                             @validate_voucher_code="validateVoucher"
                             @null_voucher_response="nullVoucherResponse"
                             @update_response_after_error="updateVoucherResponseAfterError"
        ></CheckoutVoucherCode>
        <div class="pt-2 pb-1 mb-5">
            <div class="d-flex justify-content-between align-items-center">
                <div class=" ">Total Items: {{basket_quantity}}</div>
                <div class=" strong">
                    <div class="float-sm-right">
                        Total:
                        <span class="font-weight-bold"
                              v-html="rawPrice(basket_total,false)"></span>
                    </div>
                </div>
                <div class=" ">
                    <div v-on:click="clear_basket"
                         class="btn-outline btn-sm float-sm-right"
                         style="text-align:center; box-shadow: 0 2px 5px 0 #eee, 0 2px 10px 0 #ddd; text-transform: uppercase; cursor:pointer;"
                    >Cancel Order
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {truncate} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.string';
    import {format as price} from "../../../../../app/Shared/Resources/Assets/js/helpers/money";

    window.Vue.component('CheckoutVoucherCode', require('./CheckoutVoucherCode'));
    export default {
        name: "checkout-items",
        components: {},
        props: {
            //:voucher_code_status="voucher_code_status"
            voucher_code_status: {
                type: Number,
                default: null
            },
            voucher_response: {
                type: Boolean,
                default: null
            },
            ticket_types: {
                type: Array,
                default: () => ['season', 'bulk', 'vip', 'single']
            },
            basket: {
                type: Object,
                default: {}
            },
            basket_contents: {
                type: Array | Object,
                default: () => []
            },
        },
        data() {
            return {
                current_types: [],
                /**
                 * @param {object} basket_records.basket_items
                 * @namespace basket_records
                 */
                basket_records: {},
                basket_total: 0,
                basket_quantity: 0
            }
        },
        mounted() {
            this.updateCurrentTypes();
        },
        methods: {
            log() {
                console.log.apply(console, arguments);
            },
            updateVoucherResponseAfterError() {
                this.$emit('update_response_after_error');
            },
            validateVoucher(voucher) {
                this.$emit('validate_voucher_code', voucher);
            },
            clear_basket() {
                this.$emit('clear_basket');
            },
            nullVoucherResponse() {
                this.$emit('null_voucher_response');
            },
            add(id, ticket) {
                this.$emit('add', {
                    id: id,
                    ticket: ticket
                })
            },
            remove(id) {
                this.$emit('remove', {
                    id: id
                })
            },
            truncate(str) {
                return truncate(str, 90, true)
            },
            lang(path, object) {
                return lang(path, object);
            },
            rawPrice(value) {
                //if has dots then it need rounding down
                // console.log(Math.round(value))

                return this.price(Math.round(value));
            },
            price(value) {
                return price(value, {code: Window.StripeApiConfig.cu})
            },
            log() {
                console.log.apply(console, arguments);
            },
            updateCurrentTypes() {
                let tmp = {},
                    self = this,
                    total = 0,
                    discount = 0,
                    quantity = 0;

                for (let itemKey in self.basket_contents) {
                    let basketRecord = self.basket_contents[itemKey],
                        basketItemType = basketRecord.ticket_type;

                    // create the prop for the ticket type
                    if (!tmp.hasOwnProperty(basketItemType)) {
                        tmp[basketItemType] = {};
                        basketRecord['quantity'] = 0;
                        tmp[basketItemType][basketRecord.ticket_data.ticket_id] = basketRecord;
                    }
                    // the item type exists so check if the ticket id is there now
                    else if (!tmp[basketItemType].hasOwnProperty(basketRecord.ticket_data.ticket_id)) {
                        basketRecord['quantity'] = 0;
                        tmp[basketItemType][basketRecord.ticket_data.ticket_id] = basketRecord;
                    }
                    tmp[basketItemType][basketRecord.ticket_data.ticket_id].quantity = ++tmp[basketItemType][basketRecord.ticket_data.ticket_id].quantity;

                    quantity = quantity + 1;

                    if (basketRecord.ticket_data.discount && discount == 0) {
                        discount = basketRecord.ticket_data.discount;
                        // total = total + (basketRecord.ticket_data.price - discount);
                        total = total + basketRecord.ticket_data.price;
                    } else {
                        total = total + basketRecord.ticket_data.price;
                    }
                }
                this.basket_records = tmp;
                this.basket_total = total - discount;
                this.basket_quantity = quantity;
                this.$emit('total_basket_value', total - discount);

            }
        },
        watch: {
            basket_contents: function (val) {
                this.updateCurrentTypes(val);
            }
        }
    }
</script>

<style scoped>
    .ticket--discount {
        width: 100px
    }

    .ticket-quantity {
        width: 50px;
        display: inline-block;
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutItems.vue